export const sleep = (number: number) => new Promise(r => setTimeout(r, number))
